module.exports = __webpack_public_path__ + "static/media/UC Compound Cam 03.8e92a347.webp";